<template>
  <div :class="containerClass">
    <div slot="reference" class="c-airport-input-container">
      <el-input
        v-model="airportName"
        v-focus="focusStatus"
        @input="input"
        @keyup.native="keyup"
        @keydown.native="keydown"
        @focus="focus"
        @blur="blur"
        @clear="clear"
        :clearable="true"
		:placeholder="prefixLabel"
        ref="c-selection-input"
      >
      </el-input>
    </div>
  </div>
</template>
<style scoped>
@import "./index.css";
</style>
<script type="babel">
import LOKIJS from 'lokijs';
import UTILS from "@/utils/utils.js";
import DBUtils from "@/utils/dbUtils.js";
    export default {
        data:function(){
	      	return {
	        	airportName: '',
	        	airportArray: [],
	        	airportDB: null,
	        	showHotCity: false,
	        	showSelection: false,
	        	cityOriginArray: [],
	        	cityArray: [],
	        	cityDB: null,
	        	optionArray: [],
				focusStatus: false,
				AIRPORT_ARRAY:[],
	      	}
        },
        props: {
			containerClass: {
				type: String,
				default: 'airport-selection-container',
			},
			prefixClass: {
				type: String,
				default: 'airport-selection__prefix',
			},
			prefixLabel: {
				type: String,
				default: '港口',
			},
			showHotImportCity: {
				type: Boolean,
				default: true,
			},
			focusState: {
				type: Boolean,
				default: false
			},
			defaultAirport: {
				type: String,
				default: ''
			},
			cityDB: {
				type: Array,
				default: [],
			},
			airportDB: {
				type: Array,
				default: [],
			},
			// importHotCity: {
			// 	type: Array,
			// 	default: [],
			// },
			// exportHotCity: {
			// 	type: Array,
			// 	default: []
			// }

		},
        mounted: async function() {
			if (this.defaultAirport) {
				this.airportName = this.defaultAirport
			}
		},
	    watch: {
	    	'airportName': {
	    		handler: function(value, oldValue) {
	    			value = value.toUpperCase()
	    			this.$emit('update-airport', value);
	    		}
	    	},
	    	'optionArray': {
	    		handler: function(value, oldValue) {
	    			if (value.length == 0 || this.airportName.length < 2) {
	    				this.showHotCity = true
	    			} else {
	    				this.showHotCity = false
	    			}
	    		}
	    	},
	    	'focusState': {
	    		handler: function(value, oldValue) {
	    			this.focusState = value
	    			this.focusStatus = value
	    		}
	    	}
	    },
	    directives: {
		    focus: {
		      	inserted: function(el, option) {
			        if (option.value) {
			           el.querySelector('input').focus()
			        }
			    },
			    update: function(el, option) {
			        if (option.value) {
			           el.querySelector('input').focus()
			        }
			    },
		    }
		},
	    methods: {
			queryIataFromPortDB: function(query) {
				var patt = '^' + query ;
				var reg = new RegExp(patt, "");
				return this.airportDB.where(function(obj) {
					// return !!obj.a.match(query)
					return !!reg.test(obj.a)
				});
			},
			queryPortNameFromProtDB: function(query) {
				var patt = '^' + query ;
				var reg = new RegExp(patt, "");
				return this.airportDB.where(function(obj) {
					return !!reg.test(obj.d) || !!reg.test(obj.b)
				});
			},
			filterAirport: function(query) {
				this.airportArray = [];
				if (query) {
					var length = 0;
					var letterPatt = /[^\a-z\A-Z]/g;
					var notOnlyLetter = !!query.match(letterPatt)

					length = query.length;
					if (length < 2) {
						this.airportArray = [];
						return
					}
					var tempPortList = notOnlyLetter ? this.queryPortNameFromProtDB(query) : this.queryIataFromPortDB(query.toUpperCase())

					for (var i = 0; i < tempPortList.length; i++) {
						var temp = tempPortList[i]
						temp.active = false
						this.airportArray.push(temp)
					}
				}
			},
			filterCity: function(query) {
				this.optionArray = [];
				if (query) {
					var length = 0;
					var letterPatt = /[^\a-z\A-Z]/g;
					var notOnlyLetter = !!query.match(letterPatt)
					length = query.length;
					if (length < 2) {
						return
					}
					var dbCity = notOnlyLetter ? this.queryCityZH(query) : this.queryCity(query.toUpperCase())  || []
					if (dbCity.length == 0) {
						var dbPort = notOnlyLetter ? this.queryPortZH(query) : this.queryPort(query.toUpperCase()) || []
						for (var i = dbPort.length - 1; i >= 0; i--) {
							var port = dbPort[i]
							port.uuid = UTILS.uuid()
							port.type = 2
							this.optionArray.push(port)
						}
					} else {
						for (var i = dbCity.length - 1; i >= 0; i--) {
							var city = dbCity[i]
							city.type = 1
							city.uuid = UTILS.uuid()
							this.optionArray.push(city)
							var cityCode = dbCity[i].cc
							var ports = this.listPortByCity(cityCode) || []
							for (var j = ports.length - 1; j >= 0; j--) {
								var port = ports[j]
								port.uuid = UTILS.uuid()
								port.type = 2
								this.optionArray.push(port)
							}
						}
					}
				}
			},
			queryCity: function(query) {
				var patt = '^' + query ;
				var reg = new RegExp(patt, "");
				return this.cityDB.where(function(obj) {
					return reg.test(obj.cc)
				});
			},
			queryCityZH: async function(query) {
				await DBUtils.getCityZh(query).then(res=>{
                   return res
                });
			},
			listPortByCity: function (query) {
				var patt = '^' + query ;
				var reg = new RegExp(patt, "");
				return this.airportDB.where(function(obj) {
					return reg.test(obj.cc)
				});
			},
			queryPort: function(query) {
				var patt = '^' + query ;
				var reg = new RegExp(patt, "");
				return this.airportDB.where(function(obj) {
					return reg.test(obj.pc)
				});
			},
			queryPortZH: async function(query) {
				await DBUtils.getPortZh(query).then(res=>{
					return res
				});
			},
	    	keydown: function(e) {
				var keyCode = e.keyCode;
		      	if (keyCode ==9) {
		      		// tab
		      		var length = this.optionArray
		      		if (length == 1) {
		      			this.chooseOptionAtIndex(0)
		      			this.tabNextSelection()
		      			return
		      		}
		      		var curIndex = this.getActiveIndex()
		      		if (curIndex == -1) {
		      			this.chooseOptionAtIndex(0)
		      		} else {
		      			this.chooseOptionAtIndex(curIndex)
		      		}
		      		this.tabNextSelection()
		      	}
	    	},
	    	tabNextSelection: function() {
	    		this.$emit('tab', '');
	    	},
	    	input: function(e) {
	    		this.airportName = e.trim().toUpperCase()
	    	},
	    	clear: function() {
	    		this.airportName = '';
	    		this.optionArray = [];
	    	},
	    	keyup: function(e) {
		      	var keyCode = e.keyCode;
		      	if (keyCode > 64 && keyCode < 91) {
		      		// this.filterAirport(this.airportName)

		      		this.filterCity(this.airportName)
		      	}
		      	if (keyCode == 8 || keyCode === 32) {
		      		// this.filterAirport(this.airportName)
		      		this.filterCity(this.airportName)
		      	}
		      	if (keyCode == 40) {
		      		//向下
		      		this.activeBackOption()
		      	}
		      	if (keyCode == 38) {
		      		//向上
		      		this.activeFrontOption()
		      	}
		      	if (keyCode == 13) {
		      		//enter
		      		var length = this.optionArray
		      		if (length == 1) {
		      			this.chooseOptionAtIndex(0)
		      			return
		      		}
		      		var curIndex = this.getActiveIndex()
		      		if (curIndex == -1) {
		      			this.chooseOptionAtIndex(0)
		      		} else {
		      			this.chooseOptionAtIndex(curIndex)
		      		}
		      	}


	    	},
	    	activeFrontOption: function() {
	    		var length = this.optionArray.length
	    		if (length <= 1) {
	    			return
	    		}
	    		var curIndex = this.getActiveIndex();
	    		if (curIndex == 0 || curIndex == -1) {
	    			this.activeOptionAtIndex(parseInt(length) -1)
	    		} else {
	    			this.activeOptionAtIndex(curIndex -1)
	    		}
	    	},
	    	activeBackOption: function() {
	    		var length = this.optionArray.length
	    		if (length <= 1) {
	    			return
	    		}
	    		var curIndex = this.getActiveIndex();
	    		if (curIndex == length -1 || curIndex == -1) {
	    			this.activeOptionAtIndex(0)
	    		} else {
	    			this.activeOptionAtIndex(curIndex + 1)
	    		}
	    	},
	    	getActiveIndex: function() {
	    		var array = this.optionArray
	    		var index = -1;
	    		for (var i = array.length - 1; i >= 0; i--) {
	    			var temp = array[i]
	    			if (temp.active) {
	    				index = i
	    				break
	    			}
	    		}
	    		return index;
	    	},
	    	activeOptionAtIndex: function(idx) {
	    		var tempArray = []
	    		for (var i = 0; i < this.optionArray.length; i++ ) {
	    			var temp = this.optionArray[i]
    				temp.active = i == idx
    				tempArray.push(temp)
	    		}
	    		this.optionArray = tempArray;
	    		// Vue.set(this, 'airportArray', this)
	    	},
	    	chooseOptionAtIndex: function(idx) {
	    		if (this.optionArray.length == 0) {
	    			return
	    		}
	    		var unit = this.optionArray[idx]
	    		this.airportName = unit.type == 1 ? unit.cc : unit.pc
	    		// this.hidePopover()
				this.$refs['c-selection-input'].blur()
	    	},
	    	change: function(e) {
	    	},
	    	focus: function(e) {
	    		this.showSelection = true
	    		var value = e ? e.target.value : '';
	    		this.showHotCity = !value
	    		if (!this.showHotCity) {
	    			// this.filterAirport(value)
	    			this.filterCity(this.airportName)
	    		}
	    	},
	    	blur: function() {
	    		var idx = this.getActiveIndex()
	    		if (idx == -1) {
	    			this.chooseOptionAtIndex(0)
	    			this.showSelection = false
	    			this.$emit('blur-notify', null);
	    			return
	    		}
	    		this.chooseOptionAtIndex(idx)
	    		this.showSelection = false
	    		this.$emit('blur-notify', null);
	    	},
	    	hoverOption: function(uuid) {
	    		var tempArray = []
	    		for (var i = 0; i < this.optionArray.length; i++) {
	    			var unit = this.optionArray[i]
	    			unit.active =  unit.uuid == uuid
	    			tempArray.push(unit)
	    		}
	    		this.optionArray = tempArray;
	    	},
	    	chooseHotCity: function(cityCode, pId) {
	    		this.airportName = cityCode;
	    		// this.hidePopover()
	    	},
	    	chooseOption: function(option) {
	    		this.airportName = option.type == 1 ?  option.cc : option.pc;
				// this.hidePopover()
	    	},
	    	hidePopover: function(id) {
	    		this.$refs['popover-airport'].doClose()
	    	},

	    }
    };
</script>
